import $ from 'zepto';
import util from '../common/util.js';
import user from '../common/user.js';
import msgbox from '../common/msgbox.js';
var tpl = require('../tpl/pay_test.tpl');
// var template = require('../common/template.js');
import template from '../common/template.js';
var actid = window.active_cfg.base.actid;
var cfg = '';
var payway = '';
var ajax = util.ajax;
var version = 0;
var weixinInstall = false;
var alipayInstall = false;

var payid;
var shouleiPayType = 1; //手雷支付类型 1代表微信，2代表支付宝

if (util.isShouLei() && util.isAndroid()) {
    clientInterface.device.getAppMetaData(function(data) {
        version = data['versionCode'];
    })
    client.app.checkAppInstalled({
        appSchemes: ['com.tencent.mm', 'com.eg.android.AlipayGphone'] // ['mqq', 'weixin'] appSchemes参数必须数组
    }, function(data) {
        if (version >= 10907 && version < 10915) {
            weixinInstall = false;
            alipayInstall = false;
        } else {
            weixinInstall = data['com.tencent.mm'];
            alipayInstall = data['com.eg.android.AlipayGphone'];
        }

    });

}
/**
 * 初始化页面支付浮层
 * @param  string subpayid 支付浮层aid
 * @return null
 */
function initPage(subpayid) {

    if (!subpayid) {
        for (var x in active_cfg.pay) {
            subpayid = x;
            break;
        }
    }
    payid = subpayid;
    var month = [];
    cfg = active_cfg['pay'][subpayid];
    payway = cfg['payway'] || '';

    for (var i in cfg['price']) {
        cfg['price'][i]['month'] = i
        cfg['price'][i]['monthunit'] = '个月'
        if (payway == 'auto_bj') {
            cfg['price'][i]['tips'] = '连续包月';
        }

        if (cfg['price'][i]['tips'] != '' && cfg['price'][i]['tips'].indexOf('(') == -1) {
            cfg['price'][i]['tips'] = ' ( ' + cfg['price'][i]['tips'] + ' )';

        }
        month.push(cfg['price'][i]);

    }

    window.aidfrom = cfg['aidfrom'] || '';

    $('#pay-pop').remove();
    shouleiPayType = weixinInstall ? '1' : '2';
    var html = template.build(tpl)({
        listData: cfg['pricedesc'] == 1 ? month.reverse() : month,
        monthinfo: cfg['monthinfo'] || 0,
        weixinInstall: weixinInstall,
        alipayInstall: alipayInstall,
        payway: payway
    })

    $('body').append(html);

    if (cfg['biztype'] == 'upgradevip' || cfg['biztype'] == 'upgradesuper' || cfg['biztype'] == 'knupsuperv1') {
        var userid = getCookie('userid');
        var vastype = getCookie('vip_vastype');
        var biztype_config = {
            upgradevip: 3,
            upgradesuper: 5,
            knupsuperv1: 14
        }
        $('#month_list').hide();
        $('#upgrade_list').show();
        var requestUrl = 'http://dypay.vip.xunlei.com/phonepay/getprice/?source=vipcenter&type=1&userid=' + userid + '&vastype=' + biztype_config[cfg['biztype']];
        ajax(requestUrl, function(rs) {
            //  返回说明：
            // ret      0 成功；1 无可升级订单;
            // prize    总价格
            // uprate   升级折扣
            // tdays    升级总天数
            // ndays    普通订单总天数
            // mtdays   迷你订单总天数
            // nprize   普通订单价格
            // mprize   迷你订单价格
            // discount 优惠折扣 （原价 = prize / discount）
            // autopayprice 自动续费价格 （仅支付宝/微信白金包月返回）
            if (rs.ret == 0) {
                // $('#div_month_update').html('<span class="selpad02"></span>');
                if (rs.uprate == 1) {
                    $('#upgrade_list').html('<li class="cho" data-days="' + rs.tdays + '" data-prize="' + rs.price + '" data-oprize=""> <i class="ico_p_radio"></i>升级剩余时间' + rs.tdays + ' 天，需 ' + rs.price + ' 元</li>');
                    $('#upgrade_list').html('<li class="cho" data-days="' + rs.tdays + '" data-prize="' + rs.price + '" data-oprize=""> <i class="ico_p_radio"></i>升级剩余时间' + rs.tdays + ' 天，仅不到12元/月升级超级会员，再送1次翻牌赢2年会员的机会&gt;</li>');
                } else {
                    $('#upgrade_list').html('<li class="cho" data-days="' + rs.tdays + '" data-prize="' + rs.price + '" data-oprize=""> <i class="ico_p_radio"></i>升级剩余时间' + rs.tdays + ' 天，需 ' + rs.price + ' 元，已打 ' + rs.uprate * 10 + ' 折</li>');
                    $('#upgrade_list').html('<li class="cho" data-days="' + rs.tdays + '" data-prize="' + rs.price + '" data-oprize=""> <i class="ico_p_radio"></i>升级剩余时间' + rs.tdays + ' 天，仅不到12元/月升级超级会员，再送1次翻牌赢2年会员的机会&gt;</li>');
                }

            } else {
                $('#upgrade_list').html('<li class="cho" data-days="' + rs.tdays + '" data-prize="' + rs.price + '" data-oprize=""> <i class="ico_p_radio"></i>升级剩余时间 无升级时长</li>');
            }
            showmoney();
            $('#oPrize').hide();
        })
    } else {
        $('#upgrade_list').hide();
        $('#month_list').show();
        // $('#oPrize').show();
    }

    if (cfg['usecash'] == 1) { //优惠券
        initCash();
    } else {
        $('#cash_zone').hide();
    }
    if (window.aidfrom != '' && typeof window.aidfrom != 'undefined') {
        $('#pay_btn').attr({
            'clickid': window.aidfrom
        });
    }
    // $('')
    $('#pay-pop h3').text(cfg['title']);
    initPayEvent();
}

/**
 * 绑定页面的支付事件
 * @return null
 */
function initPayEvent() {
    //事件綁定
    $(document).on('click', '#month_list li', function(event) {
        $('#month_list li').removeClass('cho');
        $(this).addClass('cho');
        var p = $(this).data('prize');
        var o = $(this).data('oprize');
        if (o == undefined || o == '') {
            $('#oPrize').hide();
        } else {
            $('#oPrize').show();
            $('#oPrize_num').text(o);
        }
        showmoney(p);
        return false;
    });

    //代金券列表
    $('#cash_list').on('click', 'li', function(event) {
        $('#cash_list li').removeClass('cur');
        $(this).addClass('cur');
        var item = $(this).data('item');
        $('#cash_input').val(item);
    });


    //支付
    $(document).off('click.pay').on('click.pay', '#pay_btn', function(event) {
        if (!haslogin()) {
            login();
            return false;
        }
        var month = $('.pay_form ul li.cho').attr('month');
        goPay(month, payid, actid);

        var paytype_shangbao = '';
        if (util.isWeixin()) {
            paytype_shangbao = 'wx';
        } else if (util.isShouLei() && util.isAndroid() && version >= 10710) {
            paytype_shangbao = 'shoulei';
        }

        if (xla && xla.push) {
            xla.push({
                type: 'event',
                category: 'pay_commit',
                action: 'pay_commit_qrzf',
                extdata: {
                    pageid: 'pay_hdzf_page',
                    referfrom: util.getUrlParam(location.href, 'referfrom'),
                    aidfrom: util.getUrlParam(location.href, 'aidfrom'),
                    userid: getCookie('userid'),
                    usertype: getCookie('vas_type'),
                    default_producttype: cfg.biztype,
                    default_monthtype: $("#month_list li:eq(0)").attr("month") + "m",
                    default_paytype: payway || 'zfb',
                    producttype: cfg.biztype,
                    monthtype: month + "m",
                    paytype: payway || paytype_shangbao || 'zfb'
                }
            });
        }

        return false;
    });

    $(document).on('click', '#pay-pop .xl_pop_close', function(event) {
        if (xla && xla.push) {
            xla.push({
                type: 'event',
                category: 'page_close',
                action: 'page_close_x',
                extdata: {
                    pageid: 'pay_hdzf_page',
                    referfrom: util.getUrlParam(location.href, 'referfrom'),
                    aidfrom: util.getUrlParam(location.href, 'aidfrom'),
                    userid: getCookie('userid'),
                    usertype: getCookie('vas_type')
                }
            });
        }
    });
}


/**
 * 验证展示购买价格处理
 * @param  string money
 * @return null
 */
function showmoney(money) {
    var month = $('li.cho').attr('month');
    var money = +$('li.cho').attr('data-prize');
    if (money <= 0 || (global_paycenter['cash'] == 10 && month < 3 && global_paycenter['cash_unlimit'] != 1)) { // 无效，3个月及以上
        money = money;
        $('#po_cash').val('');
    } else {
        money = money - global_paycenter['cash'];
        $('#po_cash').val(money);
    }
    $('#prize').text(money);
}

/**
 * 购买下单处理
 * @param  string month 购买的月份
 * @param  string payid 购买的浮层id
 * @param  string actid 活动id
 * @return undefined
 */
function goPay(month, payid, actid) {
    var month = month || 1,
        defaultReferfrom = active_cfg['pay'][payid]['referfrom_wap'],
        referfrom = util.getUrlParam(location.href, 'referfrom') || defaultReferfrom,
        callbackUrl,
        po_cash = $('#cash_input').val(),
        urlIndex = location.href.indexOf('?'),
        // 活动邀请
        inviteid = util.getUrlParam(location.href, 'uid') || '',
        payUrl;


    //支付完成后设置回退函数
    if (urlIndex != -1) {
        callbackUrl = location.href.substr(0, urlIndex) + '?po_pid=' + payid + '&month=' + month + '&paysucess=1';
    } else {
        callbackUrl = location.href + '?po_pid=' + payid + '&po_cash=' + po_cash + '&month=' + month + '&paysucess=1';
    }


    //增加京东支付，只要配置京东支付都直接购买，不执行后面逻辑
    if (payway == 'jd') {
        payUrl = formUrl(domainList.dypay + '/actpay/activepay/', {
            'po_way': 'jd_5',
            'po_platform': 'wap',
            'po_active': 'activeadmin',
            'po_cash': po_cash,
            'po_actid': actid,
            'po_pid': payid,
            'po_month': month,
            'po_inviteid': inviteid,
            'referfrom': referfrom,
            'aidfrom': window.aidfrom,
            'callback': +new Date().getTime(),
            'bgurl': encodeURIComponent(callbackUrl),
            'fgurl': encodeURIComponent(callbackUrl)

        })
        setCookie('submitOrder', 1);
        // window.open(payUrl);
        window.location.href = payUrl;
        return false;
    }

    //连续包月
    if (payway == 'auto_bj') {
        monthlyPay();
        return false;
    }

    //微信支付
    if (util.isWeixin()) {
        var typeUrl;
        if (location.host == 'act.vip.xunlei.com' || location.host == 'vip.xunlei.com') {
            typeUrl = 'http://act.vip.xunlei.com/weixin_huiyuan/weixin_pay/platform.html';
        } else {
            typeUrl = 'http://act.vip.xunlei.com/weixin_jsq/weixin_pay/platform.html';
        }

        payUrl = formUrl(typeUrl, {
            'userid': getCookie('userid'),
            'po_way': 'wap',
            'po_platform': 'wap',
            'po_active': 'activeadmin',
            'po_cash': po_cash,
            'po_actid': actid,
            'po_pid': payid,
            'month': month,
            'po_inviteid': inviteid,
            'referfrom': referfrom,
            'aidfrom': window.aidfrom,
            'callback': +new Date().getTime(),
            'bgurl': encodeURIComponent(callbackUrl),
            'fgurl': encodeURIComponent(callbackUrl)

        })
        setCookie('submitOrder', 1);
        window.open(payUrl);
        return false;
    }

    //如何是手雷
    if (util.isShouLei() && util.isAndroid() && version >= 10710 && version < 10907) {
        var payObj = {
            payType: shouleiPayType,
            vasType: 999,
            orderType: 0,
            userid: getCookie('userid'),
            //userid: 501,
            reportRefer: referfrom,
            monthOrTDays: month,
            orderVoucher: po_cash,
            paramExt1: encodeURIComponent(JSON.stringify({
                po_actid: actid,
                po_pid: payid,
                po_inviteid: inviteid,
                po_cash: po_cash,
                po_data: ''
            }))
        };
        clientInterface.ui.pay(payObj, function(data) {
            setCookie('submitOrder', 1);
            if (data.errorCode == 0) {
                msgExit();
                msgbox('支付成功？', {
                    'btn_title': '成功',
                    'btn_class': 'refreshInfo',
                    'btn_notitle': '未支付',
                    'btn_noclass': 'refreshInfo'
                });
            } else {

            }
        })
        return false;
    } else if (util.isShouLei() && util.isAndroid() && version >= 10915) {
        // 新版的手雷支付
        var payObj = {
            payType: shouleiPayType,
            activeId: 2003001, //这里传入每个支付类型的activeId
            userid: getCookie('userid'),
            reportRefer: referfrom,
            monthOrTDays: month,
            orderVoucher: '',
            paramExt1: JSON.stringify({ //新的sdk不需要再urlencode
                actid: actid,
                pid: payid,
                po_inviteid: inviteid,
                po_cash: po_cash
            })
        };

        clientInterface.ui.pay(payObj, function(data) {
            setCookie('submitOrder', 1);
            if (data.errorCode == 0) {
                msgExit();
                msgbox('支付成功？', {
                    'btn_title': '成功',
                    'btn_class': 'refreshInfo',
                    'btn_notitle': '未支付',
                    'btn_noclass': 'refreshInfo'
                });
            } else {

            }
        })
        return false;
    }


    payUrl = formUrl(domainList.dypay + '/actpay/activepay/', {
        'po_way': 'wap',
        'po_platform': 'wap',
        'po_active': 'activeadmin',
        'po_cash': po_cash,
        'po_actid': actid,
        'po_pid': payid,
        'po_month': month,
        'po_inviteid': inviteid,
        'referfrom': referfrom,
        'aidfrom': window.aidfrom,
        'callback': +new Date().getTime(),
        'bgurl': encodeURIComponent(callbackUrl),
        'fgurl': encodeURIComponent(callbackUrl)

    });

    setCookie('submitOrder', 1);
    window.open(payUrl);

}

/**
 * 白金手机包月购买
 * @return {[type]} [description]
 */
function monthlyPay() {
    util.ajax(payUrl, function(data) {
        if (util.isWeixin()) {

            location.href = data.ext;

        } else {

            var gatewayUrl = encodeURIComponent(data.ext);
            var startUrl = 'alipays://platformapi/startapp?appId=20000067&url=' + gatewayUrl;
            var signUrl = "http://d.alipay.com/i/index.htm?iframeSrc=" + encodeURIComponent(startUrl);
            location.href = signUrl;
        }

    });
    setCookie('submitOrder', 1);
}


/**
 * 生成链接的url
 * @param  string url  提单地址
 * @param  {object} data 参数
 * @return
 */
function formUrl(url, data) {
    var requestData = data || {},
        requestArry = [];
    for (var name in data) {
        requestArry.push(name + '=' + data[name]);
    }
    return url + (url.indexOf('?') > -1 ? '&' : '?') + requestArry.join('&');
}

//代金券有关逻辑的函数;
var global_paycenter = {
    'cash_state': -1,
    cash: 0
}
//检测代金券
var cash_check = function() {
        // $('#cash_list').hide();
        if ($.trim($('#cash_input').val()).length == 16) {
            var html = '正在检测代金券...';
            $('#cash_status').html(html).show();
            var checkurl = domainList.dyact + '/cash/check_json/0/' + $.trim($('#cash_input').val()) + '?cachetime=' + new Date().getTime();
            util.ajax(checkurl, function(data) {
                global_paycenter['cash_state'] = data.state;
                check_rule(data);
            })
        } else {
            global_paycenter['cash'] = 0;
            showmoney();
            global_paycenter['cash_state'] = -1;
            $('#cash_status').html('');
        }
        try {
            if ($('#cash_input').val().indexOf('代金券') === -1) {
                $('#po_cash').val($.trim($('#cash_input').val()));
            }
            cash_tips();
        } catch (e) {}
    },
    cash_check2 = function() {
        var cash_input = $('#cash_input').val();
        var length = $.trim($('#cash_input').val()).length;
        var imgbase = 'http://img.vip.xunlei.com/img/base/';
        var imgwow = '<img src="' + imgbase + 'wow16x16.png" align="absmiddle" />';
        //检测代金券长度
        if (length && length < 16 && cash_input.indexOf('代金券') === -1 || length > 16) {
            $('#cash_status').html('您输入的代金券位数不符').show();
        } else if (length == 0) {
            global_paycenter['cash'] = 0;
            global_paycenter['cash_state'] = -1;
            showmoney();
            $('#cash_status').html('');
            cash_tips();
        } else {
            cash_check();
        }
    },
    check_rule = function(data) {
        switch (data.state) {
            case 0:
                /*if (data.cash_minus == 10 && data.unlimit != 1) {
                    $('#cash_status').show().html('该代金券仅支付3个月会员及以上可用！再省' + data.cash_minus + '元</font>！');
                } else {

                    if (getMoney() < 0) {
                        $('#cash_status').show().html('该代金券仅下单金额大于' + data.cash_minus + '元可用！再省' + data.cash_minus + '元</font>！');
                    } else {
                        $('#cash_status').show().html('该代金券可用！再省' + data.cash_minus + '元</font>！');
                    }
                }*/
                if (getMoney() < 0 || (getMoney() - data.limit_money < 0)) {
                    $('#cash_status').show().html('该代金券仅下单金额大于' + data.limit_money + '元可用！');
                    data.cash_minus = 0;
                } else {
                    $('#cash_status').show().html('该代金券可用！再省' + data.cash_minus + '元</font>！');
                    global_paycenter['can_use_cash'] = true;
                }
                global_paycenter['cash'] = data.cash_minus;
                global_paycenter['cash_unlimit'] = data.unlimit;
                showmoney();
                break;
            case 1:
                $('#cash_status').show().html('参数错误');
                global_paycenter['cash'] = 0;
                showmoney();
                break;
            case 2:
                $('#cash_status').show().html('代金券已过期');
                global_paycenter['cash'] = 0;
                showmoney();
                break;
            case 3:
                var min = parseInt(data.min) % 60;
                var hour = parseInt(parseInt(data.min) / 60);
                $('#cash_status').show().html('该代金券已被锁定，离解锁时间还剩' + hour + '小时' + min + '分钟');
                global_paycenter['cash'] = 0;
                showmoney();
                break;
            case 4:
                $('#cash_status').show().html('该代金券已经被使用');
                global_paycenter['cash'] = 0;
                showmoney();
                break;
            case 5:
                $('#cash_status').show().html('不存在该代金券');
                global_paycenter['cash'] = 0;
                showmoney();
                break;
            case 6:
                $('#cash_status').show().html('该代金券为其他用户的,您使用无效');
                global_paycenter['cash'] = 0;
                showmoney();
                break;
        }
    },
    cash_tips = function() {
        var cash_val = $('#cash_input').val();
        if (cash_val == '' || cash_val.indexOf('代金券') !== -1) {
            var cash_tips = '';
            if ($('li.cho').attr('month') >= 3) {
                cash_tips = '可用10元以下代金券';
            } else {
                cash_tips = '';
            }
            $('#cash_input').attr('placeholder', cash_tips);
            $('#cash_input').css({
                'font-size': '12px',
                'color': '#888888'
            });
        } else {
            $('#cash_input').css({
                'font-size': '14px',
                'color': '#000000'
            });
        }
    },
    getMoney = function() {
        var month = $('li.cho').attr('month');
        var money = '0.0';
        if (cfg['biztype'] == 'upgradevip' || cfg['biztype'] == 'upgradesuper' || cfg['biztype'] == 'knupsuper') {
            money = $('#nmUpdate').data('price');
        } else {
            money = cfg['price'][month]['price'];
        }
        return parseInt(money);
    };

/**
 * 代金券初始化
 * @return {[type]} [description]
 */
function initCash() {
    getCashList();
    cash_check();

    $('i.ico_down').click(function() {
        $('#cash_list').toggle();
        return false;
    });
    $('#cash_list').on('click', 'li', function() {
        var item = $(this).data('item');
        $('#cash_input').val(item);
        cash_check();
    });
    $('#cash_input').on('keyup', function() {

        cash_check2();

    }).on('blur', function() {

        cash_check2();

    })
}

/**
 * 获取用户的代金券列表
 * @return null
 */
function getCashList() {
    var url = domainList.dyact + '/cash/cash_list' + "?_ts=" + (new Date()).getTime();
    util.ajax(url, function(rs) {
        $('#cash_list').html('');
        var ret = rs.ret;
        var cash_data = rs.data;
        var html = [];
        if (ret == 0 && cash_data) {
            for (let i in cash_data) {
                var prize = i / 100;
                if (cfg.cashlist && cfg.cashlist.length > 0 && cfg.cashlist.indexOf(String(prize)) == -1) {
                    continue;
                }
                var cash = cash_data[i]['fcard'];
                html.push('<li class="" data-item="' + cash + '"><i class="ico_p_radio"></i> ' + prize + '元</li>');
            }

            if (html.length > 0) {
                $('#cash_zone').show();
            } else {
                $('#cash_zone').hide();
                return;
            }

            $('#cash_list').html(html.join('')).show();
            $('#cash_list li').eq(0).click().click();
        } else {
            $('i.ico_down').hide();
        }
    });
}

function pay(payid) {
    if (!haslogin()) {
        login();
        return false;
    }

    if (user.isChild()) {
        msgbox('抱歉，您使用的是迅雷子帐号，请使用主帐号来参加活动！');
        return false;
    }

    if (user.isMobileVip()) {
        msgbox('抱歉，手机用户不能参与此活动！');
        return false;
    }

    if (user.isStopVip()) {
        msgbox('抱歉的通知您：您是暂停用户无法参加本次活动！');
        return false;
    }

    msgExit();
    initPage(payid);
    msgbox.show('pay-pop');
    typeof send_web_pv != 'undefined' && send_web_pv('pay_pop_success');

    if (xla && xla.push) {
        xla.push({
            type: 'event',
            category: 'page_load',
            action: 'page_load_succ',
            extdata: {
                pageid: 'pay_hdzf_page',
                referfrom: util.getUrlParam(location.href, 'referfrom'),
                aidfrom: util.getUrlParam(location.href, 'aidfrom'),
                userid: getCookie('userid'),
                usertype: getCookie('vas_type')
            }
        });
    }

    return false;
}
//页面支付事件绑定
var Events = {
    'document|.act_vip|click': function() {
        payid = $(this).attr('payid');
        pay(payid);
    },
    'document|.pay_way ul li|click': function() {
        if ($(this).hasClass('cho')) {
            return false;
        }
        $('.pay_way ul li').removeClass('cho');
        $(this).addClass('cho');
        shouleiPayType = $(this).attr('data-type');
        return false;
    },
    //刷新用户身份
    'document|.refreshInfo|click': function() {
        refreshInfo();
    }
}
util.initEvents(Events);
module.exports = pay;



// WEBPACK FOOTER //
// ./src/tools/vippay_v3.js